import React from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import { TrendingUp } from 'lucide-react';
const Statistics = () => {
  return <div className="flex h-screen bg-gray-50" data-id="element-4211">
      <div className="w-20 flex-shrink-0" data-id="element-4212">
        <Sidebar data-id="element-4213" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-4214">
        <Topbar data-id="element-4215" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-4216">
          <PageHeader title="Statistiche" subtitle="Analytics e reportistica avanzata" data-id="element-4217" />

          {/* Placeholder */}
          <div className="rounded-lg border border-gray-200 bg-white p-12" data-id="element-4218">
            <div className="text-center" data-id="element-4219">
              <TrendingUp className="h-16 w-16 text-gray-300 mx-auto mb-4" data-id="element-4220" />
              <h2 className="text-xl font-semibold text-gray-700 mb-2" data-id="element-4221">
                Statistiche
              </h2>
              <p className="text-gray-500 max-w-md mx-auto" data-id="element-4222">
                Questa pagina conterrà statistiche avanzate. Coming soon.
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default Statistics;